import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";

import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionSevenTexts from "hooks/form/blocks/useSectionSevenTexts";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

function SectionTitleSubtitleParagraphForm() {
    const { buttonDelete, formHook } = useSectionSevenTexts();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, setValue, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    <GridColumn>
                        <GridRow>
                            <GridItem className={"col-xs-12-12"}>
                                <h3>Testi</h3>
                            </GridItem>
                        </GridRow>

                        <GridRow>
                            <GridItem>
                                <span>Inserisci i testi per tutte le lingue</span>
                            </GridItem>
                        </GridRow>
                    </GridColumn>

                    <GridColumn>
                        <GridRow>
                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_1}
                                            setValue={setValue}
                                            path={"text.it.text_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            autoFocus
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Sottotitolo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_2}
                                            setValue={setValue}
                                            path={"text.it.text_2"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Paragrafo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_3}
                                            setValue={setValue}
                                            path={"text.it.text_3"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo nel primo bottone"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_4}
                                            setValue={setValue}
                                            path={"text.it.text_4"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            autoFocus
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Link nel primo bottone"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_5}
                                            setValue={setValue}
                                            path={"text.it.text_5"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo nel secondo bottone"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_6}
                                            setValue={setValue}
                                            path={"text.it.text_6"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            autoFocus
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Link nel secondo bottone"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_7}
                                            setValue={setValue}
                                            path={"text.it.text_7"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_1}
                                            setValue={setValue}
                                            path={"text.en.text_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Sottotitolo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_2}
                                            setValue={setValue}
                                            path={"text.en.text_2"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Paragrafo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_3}
                                            setValue={setValue}
                                            path={"text.en.text_3"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo nel primo bottone"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_4}
                                            setValue={setValue}
                                            path={"text.en.text_4"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            autoFocus
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Link nel primo bottone"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_5}
                                            setValue={setValue}
                                            path={"text.en.text_5"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo nel secondo bottone"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_6}
                                            setValue={setValue}
                                            path={"text.en.text_6"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            autoFocus
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Link nel secondo bottone"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_7}
                                            setValue={setValue}
                                            path={"text.en.text_7"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>
                </>
            )}
        </>
    );
}

export default SectionTitleSubtitleParagraphForm;
